import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emewagesApi = createApi({
  reducerPath: 'emewages',
  baseQuery: btBaseQuery,
  tagTypes: ['Wages'],

  endpoints: (builder) => ({
    getWagess: builder.query<em_ewages[], string>({
      query: (cid) => `emwages/${cid}`,
      providesTags: ['Wages']
    }),
    getWages: builder.query<em_ewages, string>({
      query: (id) => `emwages/byid/${id}`
    }),
    getWagessByDate: builder.query<
      (em_ewages & em_memployee & em_mdepartment)[],
      any
    >({
      query: ({ cid, fdt, tdt }) => `emwages/bydate/${cid}/${fdt}/${tdt}`
    }),
    insertWages: builder.mutation({
      query: (emwages) => ({
        url: `emwages/`,
        method: 'POST',
        body: emwages
      }),
      invalidatesTags: ['Wages']
    }),
    updateWages: builder.mutation({
      query: (emwages) => ({
        url: `emwages/`,
        method: 'PUT',
        body: emwages
      }),
      invalidatesTags: ['Wages']
    }),
    deleteWages: builder.mutation({
      query: (emwages) => ({
        url: `emwages/${emwages.company}/${emwages.year}/${emwages.month}`,
        method: 'DELETE',
        body: emwages
      }),
      invalidatesTags: ['Wages']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetWagessQuery,
  useGetWagesQuery,
  useGetWagessByDateQuery,
  useLazyGetWagessByDateQuery,
  useInsertWagesMutation,
  useUpdateWagesMutation,
  useDeleteWagesMutation
} = emewagesApi;
